const getRegionTone = (
  imageData,
  startRow,
  endRow,
  startColumn,
  endColumn
) => {
  const { data, width } = imageData;
  let luminanceTotal = 0;
  let pixelCount = 0;

  for (let y = startRow; y < endRow; y += 1) {
    for (let x = startColumn; x < endColumn; x += 1) {
      const offset = (y * width + x) * 4;
      const alpha = data[offset + 3] / 255;
      const red = data[offset] * alpha + 255 * (1 - alpha);
      const green = data[offset + 1] * alpha + 255 * (1 - alpha);
      const blue = data[offset + 2] * alpha + 255 * (1 - alpha);
      luminanceTotal += red * 0.2126 + green * 0.7152 + blue * 0.0722;
      pixelCount += 1;
    }
  }

  return luminanceTotal / pixelCount < 145 ? 'dark' : 'light';
};

const getNaturalSize = mediaElement =>
  mediaElement instanceof HTMLVideoElement
    ? { width: mediaElement.videoWidth, height: mediaElement.videoHeight }
    : { width: mediaElement.naturalWidth, height: mediaElement.naturalHeight };

// Aceleres: quando o elemento usa object-fit: cover (fotos/videos muito
// verticais ou muito horizontais, que ganham uma caixa fixa), o que aparece
// na tela e so um recorte central da imagem original. Sem calcular esse
// recorte, a amostra de cor caia sempre no canto da imagem INTEIRA — que
// pode ter um tom bem diferente do que de fato esta visivel atras do
// horario — e o texto saia com a cor errada (ilegivel).
const getVisibleSourceRect = mediaElement => {
  const { width: naturalWidth, height: naturalHeight } =
    getNaturalSize(mediaElement);
  const displayWidth = mediaElement.clientWidth || naturalWidth;
  const displayHeight = mediaElement.clientHeight || naturalHeight;

  if (!naturalWidth || !naturalHeight || !displayWidth || !displayHeight) {
    return {
      sx: 0,
      sy: 0,
      sWidth: naturalWidth || 1,
      sHeight: naturalHeight || 1,
    };
  }

  const scale = Math.max(
    displayWidth / naturalWidth,
    displayHeight / naturalHeight
  );
  const visibleWidth = Math.min(naturalWidth, displayWidth / scale);
  const visibleHeight = Math.min(naturalHeight, displayHeight / scale);

  return {
    sx: (naturalWidth - visibleWidth) / 2,
    sy: (naturalHeight - visibleHeight) / 2,
    sWidth: visibleWidth,
    sHeight: visibleHeight,
  };
};

export const detectMediaTones = mediaElement => {
  const sampleSize = 32;
  const canvas = document.createElement('canvas');
  canvas.width = sampleSize;
  canvas.height = sampleSize;
  const context = canvas.getContext('2d', { willReadFrequently: true });
  const { sx, sy, sWidth, sHeight } = getVisibleSourceRect(mediaElement);
  context.drawImage(
    mediaElement,
    sx,
    sy,
    sWidth,
    sHeight,
    0,
    0,
    sampleSize,
    sampleSize
  );
  const imageData = context.getImageData(0, 0, sampleSize, sampleSize);

  return {
    sender: getRegionTone(imageData, 0, 10, 0, 22),
    chevron: getRegionTone(imageData, 0, 10, 22, sampleSize),
    time: getRegionTone(imageData, 22, sampleSize, 18, sampleSize),
  };
};
